/* eslint-disable no-case-declarations */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import { goBack } from 'connected-react-router'
import transfertDemandeActions, {
    transfertDemandeTypes,
} from '../../../redux/demande/transfert'
import { Put } from '../../../serveur/axios'

function* transfertDemandeSagas({ response }) {
    try {
        const { id } = response
        const res = yield Put(`demande/transfert/${id}`, response)
        if (res.status === 200) {
            yield all([
                yield put(
                    transfertDemandeActions.transfertDemandeSuccess(res.data)
                ),
                yield put(goBack()),
            ])
        } else {
            yield put(transfertDemandeActions.transfertDemandeFailure(res.data))
        }
    } catch (error) {
        yield put(transfertDemandeActions.transfertDemandeFailure(error))
    }
}

export function* transfertDemandeSaga() {
    yield takeLatest(
        transfertDemandeTypes.TRANSFERT_DEMANDE_REQUEST,
        transfertDemandeSagas
    )
}
